import { Permission } from "callable-data-objects/dist/models/role";
import useCheckRole from "Hooks/APICheckRole";
import { useRole } from "Hooks/Endpoints";
import React from "react";
import { Button, Table } from "semantic-ui-react";

const PermissionTable = () => {
  const { hasRole, roles } = useCheckRole();
  const { setCreatePermission, permissions } = useRole();
  const create = () => {
    setCreatePermission({
      name: "",
      description: "",
    });
  };

  return (
    <div>
      {hasRole(roles.security.permission.roles.create) && (
        <Button primary onClick={() => create()}>
          Create Permission
        </Button>
      )}
      <Table singleLine stackable padded striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {permissions.map((p: Permission) => (
            <Table.Row key={p.id}>
              <Table.Cell width={3}>{p.name}</Table.Cell>
              <Table.Cell width={4}>{p.description}</Table.Cell>
              <Table.Cell width={4}>{p.type}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default PermissionTable;
